import type { Channel, UserResponse } from 'belo-js-sdk';

import type { DefaultBeloChatGenerics } from '../../types/types';

export type ChannelOrUserResponse<
  BeloChatGenerics extends DefaultBeloChatGenerics = DefaultBeloChatGenerics
> = Channel<BeloChatGenerics> | UserResponse<BeloChatGenerics>;

export const isChannel = <
  BeloChatGenerics extends DefaultBeloChatGenerics = DefaultBeloChatGenerics
>(
  output: ChannelOrUserResponse<BeloChatGenerics>,
): output is Channel<BeloChatGenerics> => (output as Channel<BeloChatGenerics>).cid != null;
